import React from 'react';
import OpenBrandDetail from '../../../../../../../components/link/OpenBrandDetail';
import TableFilterInput from '../../../../../../../components/table/TableFilterInput';
import OpenProductDetail from '../../../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../../../../containers/app/common/OpenPreviewProductDetail';
import DateRangePicker from '../../../../../../../components/datePicker/DateRangePicker';
import Select from '../../../../../../../components/input/Select';
import {
  DATE_FORMAT,
  DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT,
} from '../../../../../../../constants/service/common/utilConstants';
import {
  ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE,
  ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_TEXT,
  ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST,
} from '../../../../../../../constants/service/app/accountUserConstants';
import { PRODUCT_STATUS_TEXT } from '../../../../../../../constants/service/app/productConstants';
import { setDateFormat } from '../../../../../../../lib/moment';
import { setColumnWidth, setDash } from '../../../../../../../lib/common';

/**
 *  유저 장바구니 타임라인 리스트 컬럼
 */
const columns = (data) => {
  const { filterOption, onFilter, list } = data;

  return [
    {
      accessor: 'no',
      Header: '순번',
      width: 60,
      Cell: (row) => row.value,
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: setColumnWidth(list, 'storeId'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      filterable: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: true,
      width: setColumnWidth(list, 'productId'),
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      filterable: true,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'productStatus',
      Header: '상품 상태',
      width: 100,
      Cell: (row) => PRODUCT_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'productOption',
      Header: '옵션',
      width: setColumnWidth(list, 'productOption'),
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'actionLogType',
      Header: '활동 내역',
      filterable: true,
      width: 120,
      Cell: (row) => (
        <div>
          장바구니
          <span
            className={
              row.value === ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.ADD
                ? 'add'
                : row.value === ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.REMOVE
                  ? 'remove'
                  : null
            }
          >
            {ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_TEXT[row.value]}
          </span>
        </div>
      ),
      Filter: () => (
        <Select
          list={ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST}
          onChange={(actionLogType) => onFilter({ actionLogType })}
          value={filterOption.actionLogType}
          isTable
          size="large"
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '활동 시간',
      filterable: true,
      sortable: true,
      width: setColumnWidth(list, 'createDate'),
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          showTime={true}
          btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          startText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          endText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          format={DATE_FORMAT.FULL_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};

export default columns;
